import React from 'react';
import theme from './Cards.module.scss';
import { classnames } from '@/utils/html';
import { SimpleCardProps } from '.';
import { NotificationBadge } from '@ygtechnologies/bygr-frontend-component-library';

const SimpleCard: React.FC<SimpleCardProps> = ({
    className,
    children,
    highlight = false,
    onClick,
    variant = 'shadow',
    wrap = false,
    notificationBadgeNumber = 0,
}) => {
    return (
        <div
            onClick={onClick}
            className={classnames(
                theme.card,
                theme.simple,
                theme[variant],
                {
                    [theme.highlight]: highlight,
                    [theme.wrap]: wrap,
                },
                className
            )}>
            <NotificationBadge value={notificationBadgeNumber} className={theme.notificationBadge} size="large" />
            {children}
        </div>
    );
};

export default SimpleCard;
